import { ExternalLink } from 'lucide-react';
import { OFFICIAL_CONTACTS, PROJECT_CREATOR } from '../constants/contacts';
import { ONERI_LINKS } from '../constants/oneri';
import { LanguageSelector } from './LanguageSelector';


const Footer = () => {
  return (

    <footer className="bg-dark text-white mt-auto">
      <div className="container-max section-padding py-8">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 items-start">
          <div>
            <div className="flex items-center gap-3">
              <img src="/glooci_logo.png" alt="Glooci" className="h-8 w-auto" />
              <h3 className="text-lg font-bold">Glooci Platform</h3>
            </div>
            <p className="text-text-light/80 text-sm mt-3">
              CMS per la gestione di esperienze, Genius Loci, intent e prompt per agenti conversazionali IA · Glooci Platform 3.0
            </p>
            <div className="mt-4">
              <LanguageSelector className="bg-white/10 p-2 rounded-lg text-white" showIcon={true} />
            </div>
          </div>

          <div className="text-sm text-text-light/80">
            <p className="font-semibold text-white mb-2">Oneri Informativi</p>
            <ul className="space-y-1">
              {ONERI_LINKS.map((item) => (
                <li key={item.label}>
                  <a href={item.href} className="font-medium text-accent hover:text-white transition-colors">
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
            <p className="text-xs mt-2 text-text-light/60">Programmi CulturaCrea</p>
          </div>

          <div className="text-sm text-text-light/80">
            <p className="font-semibold text-white mb-2">Finanziamento</p>
            <p className="text-xs leading-relaxed">
              Programmi: GIADA (PNRR NextGenerationEU), HERA, EIDELON e Genius Loci (CulturaCrea).
            </p>
            <a href="/oneri" className="inline-flex items-center gap-1 text-accent hover:text-white mt-2 text-xs transition-colors">
              Dettagli oneri pubblicitari
            </a>
            <br />
            <a
              href="https://www.glooci.it/privacy-policy/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 text-primary hover:text-secondary mt-2 text-xs transition-colors"
            >
              Privacy Policy <ExternalLink size={11} />
            </a>
          </div>

          <div className="text-sm text-text-light/80 lg:text-right">
            <p className="font-semibold text-white mb-2">{OFFICIAL_CONTACTS.organization}</p>
            <a
              href={OFFICIAL_CONTACTS.website}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 text-primary hover:text-secondary transition-colors duration-200"
            >
              {OFFICIAL_CONTACTS.websiteLabel}
              <ExternalLink size={13} />
            </a>
          </div>
        </div>

        <div className="border-t border-white/20 mt-6 pt-5 flex flex-col md:flex-row md:items-center md:justify-between gap-2 text-xs text-text-light/60">
          <p>© 2026 Glooci Platform. Tutti i diritti riservati.</p>
          <p>
            Sviluppo{' '}
            <a
              href={PROJECT_CREATOR.website}
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary hover:text-secondary"
            >
              {PROJECT_CREATOR.name}
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
